// extracted by mini-css-extract-plugin
module.exports = {"card":"Item_card__gJozM","cardFilter":"Item_cardFilter__2HKOs","cardTitle":"Item_cardTitle__1c7qB"};